import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

export default function FeaturedComics() {
  const featuredComics = comics.filter((c) => c.rating >= 9.0).slice(0, 8);

  return (
    <section className="py-8 md:py-10 px-4 md:px-6" aria-label="推荐漫画">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-xs text-foreground-500 mt-1">高分韩漫精选，品质保证</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}